import type { FlowDocumentProcessingRetryResult } from '../types/flow-document-processing-retry-result';
import { resolveUserFacingCollectionMetaError } from './format-user-facing-document-processing-error';

export const FLOW_DOCUMENT_PROCESSING_RETRY_SUCCESS_TOAST =
  'Re-running field detection…';

export interface ApplyFlowDocumentProcessingRetryOutcomeInput {
  result: FlowDocumentProcessingRetryResult;
  toastError: (message: string) => void;
  toastSuccess: (message: string) => void;
  invalidateFlowDetail: () => Promise<void>;
}

/** Shared toast + cache refresh after retry-processing returns a typed body. */
export async function applyFlowDocumentProcessingRetryOutcome(
  input: ApplyFlowDocumentProcessingRetryOutcomeInput
): Promise<void> {
  const { result, toastError, toastSuccess, invalidateFlowDetail } = input;

  if (result.status === 'needs_reupload') {
    toastError(
      resolveUserFacingCollectionMetaError({
        needsReupload: true,
      }) ?? 'Uploaded file could not be read. Please try again.'
    );
    return;
  }

  if (result.status === 'failed') {
    toastError(
      resolveUserFacingCollectionMetaError({ status: 'failed' }) ??
        'Document processing failed. Please try again.'
    );
    return;
  }

  await invalidateFlowDetail();
  toastSuccess(FLOW_DOCUMENT_PROCESSING_RETRY_SUCCESS_TOAST);
}
